import { request } from '@/api/request'


export const getEventCode = async (eventId: string) => {
  const { data } = await request.get(`/webapi/event/code/me/${eventId}`)

  return data.value;
}

export const postEventCode = async (eventId: string, code: string) => {
  const bodyFormData = new FormData();
  bodyFormData.set('code', code);

  const { data } = await request.post(`/webapi/event/code/me/${eventId}`, bodyFormData);

  return data.value;
}